package com.iregained.site.components.sections.clinicians.styles

import com.iregained.site.theme.toSitePalette
import com.varabyte.kobweb.compose.css.*
import com.varabyte.kobweb.compose.css.Transition
import com.varabyte.kobweb.compose.css.functions.calc
import com.varabyte.kobweb.compose.css.functions.clamp
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.selectors.hover
import org.jetbrains.compose.web.css.*

val CliniciansHeroContainerStyle = CssStyle {
    base {
        Modifier.fillMaxWidth().styleModifier { property("min-height", "calc(100dvh - 80px)") }
            .position(Position.Relative)
            .overflow(Overflow.Hidden)
    }
}

val CliniciansHeroVideoStyle = CssStyle {
    base {
        Modifier.fillMaxSize()
            .position(Position.Absolute)
            .top(0.px)
            .left(0.px)
            .objectFit(ObjectFit.Cover).scale(1.05)
    }
}

val CliniciansHeroOverlayStyle = CssStyle {
    base {
        Modifier.fillMaxSize()
            .position(Position.Absolute)
            .top(0.px)
            .left(0.px)
            .backgroundColor(Colors.Black.toRgb().copyf(alpha = 0.7f))
    }
}

val CliniciansHeroContentColumnStyle = CssStyle {
    base {
        Modifier.fillMaxWidth()
            .maxWidth(1440.px)
            // THE CRITICAL FIX: Adding topBottom padding forces the container
            // to expand its min-height to fit the text, fixing the header clip and black borders!
            .padding(leftRight = 24.px, topBottom = 64.px)
            .position(Position.Relative)
    }
}

val CliniciansHeroHeadlineStyle = CssStyle {
    base {
        Modifier.color(Colors.White).fontSize(clamp(2.5.cssRem, 5.vw, 4.5.cssRem)).fontWeight(FontWeight.Bold)
            .textAlign(TextAlign.Center).lineHeight(1.1).margin(bottom = 24.px).whiteSpace(WhiteSpace.PreWrap)
            // ADDED: Text shadow guarantees legibility over bright video frames
            .textShadow(0.px, 4.px, 12.px, Colors.Black.toRgb().copyf(alpha = 0.8f))
    }
}

val CliniciansHeroSubheadlineStyle = CssStyle {
    base {
        Modifier.color(Colors.White.copyf(alpha = 0.9f)).fontSize(1.25.cssRem).maxWidth(1200.px)
            .textAlign(TextAlign.Center).lineHeight(1.6).margin(bottom = 48.px)
            // ADDED: Subtle shadow for sub-text
            .textShadow(0.px, 2.px, 6.px, Colors.Black.toRgb().copyf(alpha = 0.8f)).whiteSpace(WhiteSpace.PreLine)
    }
}

val CliniciansPrimaryButtonStyle = CssStyle {
    base {
        Modifier.backgroundColor(colorMode.toSitePalette().brand.primary).color(Colors.White)
            .padding(leftRight = 32.px, topBottom = 16.px).borderRadius(8.px).cursor(Cursor.Pointer)
            .transition(Transition.of("background-color", 200.ms))
            // ADDED: Box shadow to make the button pop off the video
            .boxShadow(0.px, 4.px, 12.px, color = Colors.Black.toRgb().copyf(alpha = 0.3f))
    }
    hover {
        Modifier.backgroundColor(colorMode.toSitePalette().brand.primaryHover)
    }
}

val CliniciansSecondaryLinkStyle = CssStyle {
    base {
        Modifier.backgroundColor(Colors.Transparent).color(Colors.White)
            // White border creates the button shape
            .border(2.px, LineStyle.Solid, Colors.White)
            // Reduced top/bottom padding slightly to account for the 2px border width
            .padding(leftRight = 32.px, topBottom = 14.px).borderRadius(8.px).cursor(Cursor.Pointer)
            .transition(Transition.of("all", 200.ms))
    }
    hover {
        Modifier.backgroundColor(Colors.White).color(colorMode.toSitePalette().custom.darkText)
    }
}

// NEW: Secondary Outline "Ghost" Button
val CliniciansSecondaryButtonStyle = CssStyle {
    base {
        Modifier.backgroundColor(Colors.Transparent).color(Colors.White)
            // White border creates the button shape
            .border(2.px, LineStyle.Solid, Colors.White)
            // Reduced top/bottom padding slightly to account for the 2px border width
            .padding(leftRight = 32.px, topBottom = 14.px).borderRadius(8.px).cursor(Cursor.Pointer)
            .transition(Transition.of("all", 200.ms))
    }
    hover {
        // On hover, fills with white and turns text dark
        Modifier.backgroundColor(Colors.White).color(colorMode.toSitePalette().custom.darkText)
    }
}